// Get product details from script tag
let productDetails = {};

function formatPopupPrice(cents) {
  const amount = Number(cents || 0) / 100;
  return '$' + amount.toFixed(2);
}

function loadProductDetails() {
  const dataScript = document.getElementById('whats-in-your-kit-product-data');
  if (dataScript) {
    try {
      const data = JSON.parse(dataScript.textContent);
      productDetails = data.products || {};
    } catch (e) {
      console.error('Error parsing product data:', e);
      productDetails = {};
    }
  }
}

// Popup Functions
function openPopup(productId) {
  const product = productDetails[productId];
  console.debug(product, "product")
  if (!product) {
    console.error('Product not found:', productId);
    return;
  }

  const popup = document.getElementById('whats-in-your-kit-popup');
  const imageWrapper = document.querySelector('.whats-in-your-kit__popup-image-wrapper');
  const image = document.getElementById('popup-product-image');
  const name = document.getElementById('popup-product-name');
  const rating = document.getElementById('popup-product-rating');
  const description = document.getElementById('popup-product-description');
  const features = document.getElementById('popup-product-features');
  const steps = document.getElementById('popup-product-steps');
  const popupAddToCartButton = document.getElementById('popup-product-add-to-cart');
  const popupViewDetailsButton = document.getElementById('popup-product-view-details');

  // Set image or gray placeholder
  if (product.image) {
    image.src = product.image;
    image.alt = product.title;
    image.style.display = 'block';
    imageWrapper.classList.remove('no-image');
  } else {
    image.style.display = 'none';
    imageWrapper.classList.add('no-image');
  }

  // Set name
  name.textContent = product.title || 'Product';

  // Set rating
  rating.innerHTML = '';
  const productRating = product.rating || 4.5;
  const stars = Math.floor(productRating);
  for (let i = 0; i < 5; i++) {
    const star = document.createElement('span');
    star.className = 'star';
    star.innerHTML = i < stars 
      ? '<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.31982 13.3047L4.6792 16.1172L5.90967 10.8438L1.83154 7.29297L7.21045 6.83594L9.31982 1.87891L11.4292 6.83594L16.8081 7.29297L12.73 10.8438L13.9604 16.1172L9.31982 13.3047Z" fill="#EEA148"/></svg>'
      : '<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.31982 13.3047L4.6792 16.1172L5.90967 10.8438L1.83154 7.29297L7.21045 6.83594L9.31982 1.87891L11.4292 6.83594L16.8081 7.29297L12.73 10.8438L13.9604 16.1172L9.31982 13.3047Z" fill="#EEA148"/></svg>';
    rating.appendChild(star);
  }
  const ratingNumber = document.createElement('span');
  ratingNumber.className = 'rating-number';
  ratingNumber.textContent = productRating;
  rating.appendChild(ratingNumber);

  // Set description
  description.textContent = product.description || '';

  // Set features
  features.innerHTML = '';
  if (product.features && product.features.length > 0) {
    product.features.forEach(feature => {
      const featureDiv = document.createElement('div');
      featureDiv.className = 'whats-in-your-kit__popup-feature';
      
      if (feature.icon) {
        const iconImg = document.createElement('img');
        iconImg.src = feature.icon;
        iconImg.alt = feature.title || '';
        iconImg.className = 'whats-in-your-kit__popup-feature-icon';
        featureDiv.appendChild(iconImg);
      }
      
      if (feature.title) {
        const featureText = document.createElement('span');
        featureText.className = 'whats-in-your-kit__popup-feature-text';
        featureText.textContent = feature.title;
        featureDiv.appendChild(featureText);
      }
      
      features.appendChild(featureDiv);
    });
  }

  // Hide "How To Use" section (not used in current implementation)
  const howToUseSection = steps.closest('.whats-in-your-kit__popup-how-to-use');
  howToUseSection.style.display = 'none';

  // Store current product context on popup action buttons
  if (popupAddToCartButton) {
    popupAddToCartButton.dataset.variantId = String(product.variant_id || productId || '');
    const addToCartText = 'Add to cart - ' + formatPopupPrice(product.price);
    popupAddToCartButton.dataset.defaultText = addToCartText;
    popupAddToCartButton.textContent = addToCartText;
  }
  if (popupViewDetailsButton) {
    popupViewDetailsButton.dataset.productUrl = product.url || '';
  }

  // Show popup
  popup.classList.add('active');
  document.body.style.overflow = 'hidden';
}

function closePopup() {
  const popup = document.getElementById('whats-in-your-kit-popup');
  popup.classList.remove('active');
  document.body.style.overflow = '';
}

// Event Listeners
document.addEventListener('DOMContentLoaded', function() {
  // Load product details from script tag
  loadProductDetails();

  // View Details button clicks
  const viewDetailsButtons = document.querySelectorAll('.whats-in-your-kit__item-link[data-product-id]');
  viewDetailsButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const productId = this.getAttribute('data-product-id');
      if (productId && productDetails[productId]) {
        openPopup(productId);
      }
    });
  });

  // Close button
  const closeButton = document.querySelector('.whats-in-your-kit__popup-close');
  if (closeButton) {
    closeButton.addEventListener('click', closePopup);
  }

  // Overlay click to close
  const overlay = document.querySelector('.whats-in-your-kit__popup-overlay');
  if (overlay) {
    overlay.addEventListener('click', closePopup);
  }

  // ESC key to close
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closePopup();
    }
  });

  // Popup "Add to Cart" button
  const popupAddToCartButton = document.getElementById('popup-product-add-to-cart');
  if (popupAddToCartButton && popupAddToCartButton.dataset.wiykBound !== '1') {
    popupAddToCartButton.dataset.wiykBound = '1';
    popupAddToCartButton.addEventListener('click', function() {
      const variantId = this.dataset.variantId;
      if (!variantId) return;
      if (this.dataset.wiykSubmitting === '1') return;

      this.dataset.wiykSubmitting = '1';
      const originalText = this.dataset.defaultText || this.textContent;
      this.disabled = true;
      this.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1
            }
          ]
        })
      })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }
        return response.json();
      })
      .then(function() {
        popupAddToCartButton.textContent = 'Added to Cart';

        return fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cartData) {
            if (typeof window.updateCart === 'function') {
              window.updateCart(cartData);
            }
            if (typeof window.openCartDrawer === 'function') {
              window.openCartDrawer();
            } else if (typeof window.theme !== 'undefined' && window.theme.cartDrawer) {
              window.theme.cartDrawer.open();
            }
          })
          .catch(function() {
            if (typeof window.openCartDrawer === 'function') {
              window.openCartDrawer();
            } else if (typeof window.theme !== 'undefined' && window.theme.cartDrawer) {
              window.theme.cartDrawer.open();
            }
          });
      })
      .catch(function(error) {
        console.error('Error adding popup product to cart:', error);
        popupAddToCartButton.textContent = 'Error - Try Again';
      })
      .finally(function() {
        setTimeout(function() {
          popupAddToCartButton.textContent = originalText;
          popupAddToCartButton.disabled = false;
          popupAddToCartButton.dataset.wiykSubmitting = '0';
        }, 1000);
      });
    });
  }

  // Popup "View Details" button
  const popupViewDetailsButton = document.getElementById('popup-product-view-details');
  if (popupViewDetailsButton && popupViewDetailsButton.dataset.wiykBound !== '1') {
    popupViewDetailsButton.dataset.wiykBound = '1';
    popupViewDetailsButton.addEventListener('click', function() {
      const productUrl = this.dataset.productUrl;
      if (!productUrl) return;
      window.open(productUrl, '_blank');
    });
  }
});
